export default __webpack_public_path__ + "static/success-gif-d5db6c1e7b8d02187a8c1a2e591bd964.gif";